import React from "react";

export const CloseWhiteIcon = () => {
  return (
    <>
      <svg
        width="18"
        height="18"
        viewBox="0 0 25 25"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M0.522383 0.545158C0.856965 0.210388 1.31069 0.0223246 1.78379 0.0223246C2.25689 0.0223246 2.71062 0.210388 3.04521 0.545158L12.4888 9.99694L21.9325 0.545158C22.0971 0.374604 22.2939 0.238564 22.5116 0.144977C22.7293 0.051389 22.9634 0.00212781 23.2003 6.74233e-05C23.4372 -0.00199296 23.6722 0.0431883 23.8914 0.132976C24.1107 0.222763 24.3099 0.355358 24.4774 0.523023C24.6449 0.690689 24.7774 0.890067 24.8671 1.10953C24.9568 1.32898 25.002 1.56413 24.9999 1.80123C24.9979 2.03834 24.9487 2.27266 24.8551 2.49052C24.7616 2.70839 24.6257 2.90543 24.4553 3.07016L15.0117 12.5219L24.4553 21.9737C24.7803 22.3105 24.9601 22.7616 24.9561 23.2298C24.952 23.698 24.7644 24.1459 24.4336 24.477C24.1028 24.8081 23.6553 24.9959 23.1875 24.9999C22.7197 25.004 22.269 24.824 21.9325 24.4987L12.4888 15.0469L3.04521 24.4987C2.70871 24.824 2.25802 25.004 1.79021 24.9999C1.32241 24.9959 0.874917 24.8081 0.544116 24.477C0.213316 24.1459 0.0256753 23.698 0.0216102 23.2298C0.0175451 22.7616 0.197381 22.3105 0.522383 21.9737L9.96602 12.5219L0.522383 3.07016C0.187901 2.73529 0 2.28116 0 1.80766C0 1.33415 0.187901 0.880029 0.522383 0.545158Z"
          fill="white"
          style={{ fill: "white", fillOpacity: 1 }}
        />
      </svg>
    </>
  );
};
